// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ZEGC","bigColWidth":"Table_bigColWidth__188yr","biggerColWidth":"Table_biggerColWidth__15JhJ","row":"Table_row__3faHk","col":"Table_col__ZsRDv"};